export type HolidayBannerBackground = 'black-gold' | 'purple';

export type HolidayBannerTextPart = {
  text: string;
  bold?: boolean;
};

export type HolidayBannerConfig = {
  startDate: string;
  endDate: string;
  textParts: HolidayBannerTextPart[];
  background: HolidayBannerBackground;
  campaignUrl?: string;
};

/**
 * Default banner configuration (purple background)
 * Shown when no scheduled banner is active
 */
export const DEFAULT_HOLIDAY_BANNER: HolidayBannerConfig = {
  startDate: '',
  endDate: '',
  textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for orders above {{threshold}}' }],
  background: 'purple',
};

/**
 * Holiday Banner rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const HOLIDAY_BANNER_ROTATIONS: HolidayBannerConfig[] = [
  // GGU Phase 1: The Glow Lab - Jun 10 (3PM) - Jun 24 (3PM)
  {
    startDate: '2026-06-10 15:00:00',
    endDate: '2026-06-24 15:00:00',
    textParts: [
      { text: 'The Glow Lab: ', bold: true },
      { text: 'Up to 50% OFF Sitewide!' },
    ],
    background: 'purple',
    campaignUrl: '/campaign/great-glow-up/',
  },
  // GGU Phase 2: The Great Glow Up - Jun 24 (3PM) - Jul 1 (3PM)
  {
    startDate: '2026-06-24 15:00:00',
    endDate: '2026-07-01 15:00:00',
    textParts: [
      { text: 'The Great Glow Up: ', bold: true },
      { text: 'Up to 70% OFF Sitewide' },
    ],
    background: 'purple',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  // Centellian24 Free Sample - Jul 20 (3PM) - Jul 24 (3PM)
  {
    startDate: '2026-07-20 15:00:00',
    endDate: '2026-07-24 15:00:00',
    textParts: [
      { text: 'Free Sample 15ml for Every Purchase of' },
      { text: ' Centellian24 ', bold: true },
      { text: 'Products' },
    ],
    background: 'purple',
    campaignUrl: '/brand/centellian24/',
  },
  // School's In - Aug 11 (3PM) - Aug 18 (3PM)
  {
    startDate: '2026-08-11 15:00:00',
    endDate: '2026-08-18 15:00:00',
    textParts: [{ text: "School's in! Get ready for " }, { text: 'Up to 50% OFF', bold: true }],
    background: 'purple',
    campaignUrl: '/campaign/schools-in/',
  },
  // The Lab: Cica - Aug 18 (3PM) - Aug 25 (3PM)
  {
    startDate: '2026-08-18 15:00:00',
    endDate: '2026-08-25 15:00:00',
    textParts: [{ text: 'Shop Cica Products NOW. ' }, { text: 'Up to 30% OFF', bold: true }],
    background: 'purple',
    campaignUrl: '/campaign/the-lab-cica/',
  },
  // Self Care - Aug 25 (3PM) - Sep 1 (3PM)
  {
    startDate: '2026-08-25 15:00:00',
    endDate: '2026-09-01 15:00:00',
    textParts: [{ text: 'Treat your skin NOW. ' }, { text: 'Up to 50% OFF', bold: true }],
    background: 'purple',
    campaignUrl: '/campaign/self-care/',
  },
];

export const HOLIDAY_BANNER_TIMEZONE = 'Asia/Singapore';
